import React, { useCallback } from 'react';
import Gallery from './Gallery';
import GalleryMigration from './GalleryMigration';
import _sortBy from 'lodash/sortBy';
import { areEqual, removeForbiddenCharacters } from '../../../utils/helpers';
import useMediaBreakpoints from '../../../hooks/useMediaBreakpoints';
interface PhotosProps {
  photos: any;
  openLightbox: any;
  isOtherProfile?: boolean;
  photoData?: any;
  migration?: boolean;
  profile?: any;
}

const Photos = ({ profile, photos, openLightbox, isOtherProfile, photoData, migration }: PhotosProps): any => {
  const { isMobile } = useMediaBreakpoints();

  const generatePhotoList = useCallback(() => {
    const photoList = [];

    photoData &&
      photoData.data.map(photo => {
        photo['order'] = parseInt(removeForbiddenCharacters(photo?.created_dt?.date));

        if (photo.id === null) {
          photo['rank'] = 2;

          return photo;
        }

        photo['rank'] = photo.private || photo.id === null ? 2 : 1;

        if (isMobile || !isOtherProfile) {
          if (photo.is_avatar) photo['rank'] = 0;
          photoList.push(photo);
        } else if (!photo.is_avatar) {
          photoList.push(photo);
        }

        return photo;
      });

    return { data: _sortBy(photoList, ['rank', 'order']) };
  }, [photoData]);

  const generateOtherProfilePhotoList = useCallback(() => {
    if (isMobile) {
      return photos;
    }

    return photos.filter(photo => !photo.is_avatar);
  }, [photos]);

  return !migration ? (
    <Gallery
      images={generateOtherProfilePhotoList()}
      openLightbox={(inx, e) => {
        const photoInx = isMobile || !isOtherProfile ? inx : inx + 1;

        openLightbox(photoInx, e);
      }}
      isOtherProfile={isOtherProfile}
      photos={generatePhotoList()}
      profile={profile}
    />
  ) : (
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    <GalleryMigration images={photos} openLightbox={openLightbox} />
  );
};

export default React.memo(Photos, areEqual);
